import api from './api';
import { CPB_URL } from './servers';

export const fetchIndicadores = (data) => api.post(`${CPB_URL}/indicadores/getIndicadores`, data);
